<template>
  <div @click="handleClosePreview">
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="content-top">
          <div class="go-back" @click="goBack">
            {{ lang === "cn" ? "返回" : "Back" }}
          </div>
          <el-button @click="validateForm('form')">{{
            lang === "cn" ? "保存" : "Save"
          }}</el-button>
        </div>
        <!-- 表单信息 -->
        <div class="content-main" v-loading="loading">
          <div class="main-title">{{ title }}</div>
          <el-form
            :model="formData"
            ref="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              :label="
                lang === 'cn' ? '产品名称（中文）' : 'Product name（Chinese）'
              "
              prop="product_name_cn"
            >
              <el-input v-model="formData.product_name_cn"></el-input>
            </el-form-item>
            <el-form-item
              :label="
                lang === 'cn' ? '产品名称（英文）' : 'Product name（English）'
              "
              prop="product_name_en"
            >
              <el-input v-model="formData.product_name_en"></el-input>
            </el-form-item>
            <el-form-item
              :label="lang === 'cn' ? '产品分类' : 'Product category'"
              prop="product_category"
            >
              <el-cascader
                :placeholder="lang === 'cn' ? '请选择' : 'Please select'"
                v-model="formData.product_category"
                :options="product_category_options"
                :props="product_category_props"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item
              :label="lang === 'cn' ? '产品标签' : 'Product tag'"
              prop="product_label"
            >
              <el-select
                multiple
                v-model="formData.product_label"
                :placeholder="lang === 'cn' ? '请选择' : 'Please select'"
              >
                <el-option
                  v-for="item in product_label_options"
                  :key="item.value"
                  :label="lang === 'cn' ? item.name : item.name_en"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="lang === 'cn' ? '产品认证' : 'Product certification'"
              prop="product_certification"
            >
              <el-select
                multiple
                v-model="formData.product_certification"
                :placeholder="lang === 'cn' ? '请选择' : 'Please select'"
              >
                <el-option
                  v-for="item in product_certification_options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="
                lang === 'cn'
                  ? '质量体系认证'
                  : 'Quality management system certification'
              "
              prop="quality_system_of_certification"
            >
              <el-select
                multiple
                v-model="formData.quality_system_of_certification"
                :placeholder="lang === 'cn' ? '请选择' : 'Please select'"
              >
                <el-option
                  v-for="item in quality_system_of_certification_options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="
                lang === 'cn'
                  ? '是否支持提供样品'
                  : 'Do you support providing samples'
              "
              prop="if_provide_sample"
            >
              <el-select
                v-model="formData.if_provide_sample"
                :placeholder="lang === 'cn' ? '请选择' : 'Please select'"
              >
                <el-option
                  v-for="item in provide_sample_options"
                  :key="item.value"
                  :label="lang === 'cn' ? item.name : item.name_en"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="
                lang === 'cn'
                  ? '产品简介（中文）'
                  : 'Product Introduction（Chinese）'
              "
              prop="product_introduction_cn"
            >
              <el-input
                type="textarea"
                :placeholder="
                  lang === 'cn'
                    ? '请输入产品简介'
                    : 'Please enter the product Introduction（Chinese）'
                "
                v-model="formData.product_introduction_cn"
                :rows="5"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="
                lang === 'cn'
                  ? '产品简介（英文）'
                  : 'Product Introduction（English）'
              "
              prop="product_introduction_en"
            >
              <el-input
                type="textarea"
                :placeholder="
                  lang === 'cn'
                    ? '请输入产品简介'
                    : 'Please enter the product Introduction（English）'
                "
                v-model="formData.product_introduction_en"
                :rows="5"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item :label="lang === 'cn' ? '产品详情' : 'Product Details'" prop="product_details">
                <el-input type="textarea" :placeholder="lang === 'cn' ? '请输入产品详情' : 'Please enter the product details'" v-model="formData.product_details" :rows="5"></el-input>
              </el-form-item> -->
            <el-form-item
              :label="
                lang === 'cn'
                  ? '产品图片 (建议上传JPG/PNG，大小为500kb左右)'
                  : 'Product image (Around 500KB in size (JPG/PNG recommended))'
              "
              prop="product_picture"
              class="main-upload"
            >
              <div
                class="main-upload-img"
                v-for="(item, index) in formData.product_picture"
                :key="index"
              >
                <el-image fit="contain" :src="item"></el-image>
                <div class="main-upload-operate">
                  <i
                    class="el-icon-search"
                    @click.stop="handleShowPreview(index)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    @click.stop="handleDeleteLogo(index)"
                  ></i>
                </div>
              </div>
              <el-upload
                :action="$uploadImgUrl"
                :headers="headers"
                :show-file-list="false"
                :on-success="uploadLogoSuccess"
                :on-error="uploadLogoError"
                :before-upload="
                  (file) => handleBeforeUpload(file, 'product_picture')
                "
                v-if="formData.product_picture.length < 10"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
<!--            <el-form-item-->
<!--              :label="lang === 'cn' ? '主图视频' : 'Cover Video'"-->
<!--              prop="cover_video"-->
<!--            >-->
<!--              <el-upload-->
<!--                class="video-upload"-->
<!--                :action="$uploadVideoUrl"-->
<!--                :headers="headers"-->
<!--                :show-file-list="false"-->
<!--                :on-success="uploadLogoSuccess"-->
<!--                :before-upload="-->
<!--                  (file) => handleBeforeUpload(file, 'cover_video')-->
<!--                "-->
<!--                :on-error="uploadLogoError"-->
<!--                :disabled="formData.cover_video ? true : false"-->
<!--              >-->
<!--                <div class="main-upload-box">-->
<!--                  <video-->
<!--                    :src="formData.cover_video"-->
<!--                    v-if="formData.cover_video"-->
<!--                  ></video>-->
<!--                  <div class="main-upload-operate" v-if="formData.cover_video">-->
<!--                    <i-->
<!--                      class="el-icon-video-play"-->
<!--                      @click.stop="handlePlayVideo(formData.cover_video)"-->
<!--                    ></i>-->
<!--                    <i-->
<!--                      class="el-icon-delete"-->
<!--                      @click.stop="handleDeleteLogo(-1, 'cover_video')"-->
<!--                    ></i>-->
<!--                  </div>-->
<!--                  <i class="el-icon-plus" v-else></i>-->
<!--                </div>-->
<!--              </el-upload>-->
<!--            </el-form-item>-->
          </el-form>
          <div class="content-save" @click="validateForm('form')">
            {{ lang === "cn" ? "保存" : "Save" }}
          </div>
        </div>
      </div>
    </div>
    <div class="model" v-if="showPreview">
      <img
        class="preview-image"
        :src="formData.product_picture[previewImageIndex]"
        style="object-fit: contain"
      />
    </div>
  </div>
</template>
  
  <script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import {
  getDictionary,
  getProductCategory,
  addproduct,
  productDetails,
  editproduct,
} from "../api/api";
export default {
  components: { top, navMenu },
  name: "newProduct",
  data() {
    return {
      lang: "",
      active: 1,
      title: "",
      product_long_id: "",
      headers: {},
      loading: false,
      formData: {
        product_name_cn: "",
        product_name_en: "",
        product_category: [],
        product_label: "",
        product_certification: "",
        quality_system_of_certification: "",
        if_provide_sample: "0",
        product_introduction_cn: "",
        product_introduction_en: "",
        // product_details: '',
        product_picture: [],
        cover_video: "",
      },
      rules: {
        product_name_cn: [
          {
            required: true,
            message:
              "请输入产品名称（中文）/ Please Enter The Product Name(Chinese)",
            trigger: "blur",
          },
        ],
        product_category: [
          {
            required: true,
            message: "请选择产品类别 / Please Select The Product Type",
            trigger: "change",
          },
        ],
        // product_details: [
        //   { required: true, message: '请输入产品详情', trigger: 'blur' }
        // ],
        if_provide_sample: [
          {
            required: true,
            message:
              "请选择是否需要上传样品！/ Please indicate whether a physical sample submission is required",
            trigger: "change",
          },
        ],
        product_introduction_cn: [
          {
            required: true,
            message: "请输入产品简介 / Please Enter The Product Introduction",
            trigger: "blur",
          },
        ],
        product_picture: [
          {
            required: true,
            message: "请上传产品图片 / Please Upload The Product Picture",
            trigger: "change",
          },
        ],
      },
      product_category_options: [],
      product_label_options: [],
      product_certification_options: [],
      quality_system_of_certification_options: [],
      provide_sample_options: [],
      product_category_props: {},
      showPreview: false,
      previewImageIndex: -1,
      uploadField: "",
    };
  },
  created() {
    this.lang = localStorage.getItem("language");
    if (this.$route.query.id) {
      // 编辑
      if (this.lang === "cn") {
        this.title = "编辑产品";
      } else if (this.lang === "en") {
        this.title = "Edit a product";
      }
      this.product_long_id = this.$route.query.id;
    } else {
      // 创建
      if (this.lang === "cn") {
        this.title = "创建产品";
      } else if (this.lang === "en") {
        this.title = "Create a product";
      }
    }
    this.getDictionaryData();
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/conference" && item.id == 32;
    });
    this.active = index;
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
  },
  methods: {
    async getDictionaryData() {
      const res = await getDictionary(
        "type=product_structure,product_authentication,product_label,status_type"
      );
      this.product_label_options = res.data.data.product_label;
      this.product_certification_options = res.data.data.product_authentication;
      this.quality_system_of_certification_options =
        res.data.data.product_structure;
      this.provide_sample_options = res.data.data.status_type;
      this.getProductCategoryData();
    },
    async getProductCategoryData() {
      const res = await getProductCategory();
      this.product_category_options = res.data.data.lists;
      this.product_category_props = {
        label: this.lang === "cn" ? "category_name" : "en_category_name",
        value: "id",
      };
      if (this.title === "编辑产品" || this.title === "Edit a product") {
        this.getProductDetail();
      }
    },
    async getProductDetail() {
      const res = await productDetails(
        `product_long_id=${this.product_long_id}`
      );
      let data = res.data.data;
      this.formData.product_name_cn = data.product_name;
      this.formData.product_name_en = data.en_product_name;
      this.formData.product_label = data.label;
      this.formData.product_certification = data.authentication;
      this.formData.quality_system_of_certification = data.structure;
      this.formData.if_provide_sample = data.is_sample;
      this.formData.product_introduction_cn = data.introduction;
      this.formData.product_introduction_en = data.introduction_en;
      // this.formData.product_details = data.content;
      this.formData.product_picture = data.imgs;
      this.formData.cover_video = data.video;
      this.formData.product_category = [data.cid1, data.cid];
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "/productList",
      });
    },
    validateForm(formName) {
      this.$refs[formName].validate((valid, field) => {
        if (valid) {
          this.submit();
        } else {
          console.log(valid, field);
          let arr = Object.keys(field);
          let tips = field[arr[0]][0].message.split("/");
          let lang = localStorage.getItem("language");
          if (lang === "cn") {
            this.$message.error(tips[0]);
          } else if (lang === "en") {
            this.$message.error(tips[tips.length - 1]);
          }
          return false;
        }
      });
    },
    async submit() {
      let data = this.formData;
      let obj = {
        product_long_id: this.product_long_id,
        product_name: data.product_name_cn,
        en_product_name: data.product_name_en,
        cid: data.product_category[1] || "",
        cid1: data.product_category[0] || "",
        label: data.product_label,
        authentication: data.product_certification,
        structure: data.quality_system_of_certification,
        is_sample: data.if_provide_sample,
        introduction: data.product_introduction_cn,
        introduction_en: data.product_introduction_en,
        // content: data.product_details,
        image: data.product_picture[0],
        imgs: data.product_picture,
        video: data.cover_video,
      };
      if (this.title === "创建产品" || this.title === "Create a product") {
        this.createProduct(obj);
      } else if (this.title === "编辑产品" || this.title === "Edit a product") {
        this.editProduct(obj);
      }
    },
    async createProduct(data) {
      const res = await addproduct(data);
      if (res.data.code == 1) {
        this.$message.success(
          this.lang === "cn" ? "添加成功" : "Operation successful"
        );
        this.$router.push({
          path: "/productList",
        });
      } else {
        this.$message.error(res.data.msg);
        return false;
      }
    },
    async editProduct(data) {
      const res = await editproduct(data);
      if (res.data.code == 1) {
        this.$message.success(
          this.lang === "cn" ? "编辑成功" : "Operation successful"
        );
        this.$router.push({
          path: "/productList",
        });
      } else {
        this.$message.error(res.data.msg);
        return false;
      }
    },
    handleBeforeUpload(file, field) {
      this.loading = true;
      let size = file.size;
      let type = file.type;
      if (field === "product_picture") {
        if (
          type !== "image/jpeg" &&
          type !== "image/png" &&
          type !== "image/webp" &&
          type !== "image/webp" &&
          type !== "application/postscript" &&
          type !== "application/x-ai"
        ) {
          this.$message.error("请上传图片！");
          this.loading = false;
          return false;
        }
      } else if (field === "cover_video") {
        if (
          type !== "video/mp4" &&
          type !== "video/ogg" &&
          type !== "video/x-msvideo" &&
          type !== "video/x-ms-wmv" &&
          type !== "video/vnd.rn-realvideo"
        ) {
          this.$message.error("请上传视频！");
          this.loading = false;
          return false;
        }
        // console.log(type !== 'video/mp4‌‌' && type !== 'video/ogg‌‌' && type !== 'video/x-msvideo‌‌' && type !== 'video/x-ms-wmv‌‌' && type !== 'video/vnd.rn-realvideo‌‌');
        // if(type !== 'video/mp4‌‌' && type !== 'video/ogg‌‌' && type !== 'video/x-msvideo‌‌' && type !== 'video/x-ms-wmv‌‌' && type !== 'video/vnd.rn-realvideo‌‌') {
        //   this.$message.error('请上传视频！');
        //   return false;
        // }
        if (size / (1024 * 1024) > 60) {
          this.$message.error("文件大小不可超出60M！");
          this.loading = false;
          return false;
        }
      }
      this.uploadField = field;
    },
    handleShowPreview(index) {
      this.showPreview = true;
      this.previewImageIndex = index;
    },
    handleClosePreview() {
      this.showPreview = false;
      this.previewImageIndex = -1;
    },
    handlePlayVideo(url) {
      window.open(url, "_blank");
    },
    handleDeleteLogo(index, field) {
      if (index === -1) {
        this.formData[field] = "";
      } else {
        this.formData.product_picture.splice(index, 1);
      }
    },
    uploadLogoSuccess(res) {
      if (this.uploadField === "product_picture") {
        this.formData[this.uploadField].push(res.data.uri);
      } else {
        this.formData[this.uploadField] = res.data.uri;
      }
      this.uploadField = "";
      this.loading = false;
    },
    uploadLogoError() {
      this.uploadField = "";
      this.$message.error("上传图片失败");
      return false;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.content .el-button {
  color: #fff;
  position: absolute;
  bottom: 30px;
  left: 50%;
  background: #008dff;
}
.go-back {
  margin-bottom: 20px;
}
.content {
  padding-bottom: 40px;
  .content-top {
    display: flex;
    position: fixed;
    top: 100px;
    left: 260px;
    z-index: 99;
    width: 100%;
    padding: 30px 0 20px;
    background: #f1f5f8;
    .el-button {
      position: relative;
      left: 0;
      bottom: 0;
      height: 44px;
      line-height: 44px;
      margin-left: 20px;
      transform: translateX(0);
    }
  }
  .content-main {
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 40px 40px;
    border-radius: 10px;
    margin-top: 85px;
    .el-form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-form-item {
        width: 32%;
        margin-bottom: 12px;
        /deep/ .el-form-item__label {
          padding-bottom: 0;
        }
        .el-cascader {
          width: 100%;
        }
        .el-select {
          width: 100%;
        }
      }
      .main-upload {
        width: 100%;
        display: block;
        /deep/ .el-form-item__content {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .main-upload-img {
            width: 152px;
            margin-right: 12px;
            height: 152px;
            position: relative;
            .el-image {
              width: 100%;
              height: 100%;
            }
            .main-upload-operate {
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.7);
              position: absolute;
              left: 0;
              top: 0;
              box-sizing: border-box;
              display: none;
              i {
                font-size: 28px;
                color: #008dff;
                cursor: pointer;
              }
              i:first-child {
                margin-right: 10px;
              }
              i:last-child {
                margin-left: 10px;
              }
            }
          }
          .main-upload-img:hover .main-upload-operate {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .el-upload {
            width: 152px;
            height: 152px;
            box-sizing: border-box;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            position: relative;
            i {
              font-size: 36px;
              color: #8c939d;
              line-height: 148px;
              text-align: center;
            }
          }
        }
      }
      .video-upload {
        width: 152px;
        height: 152px;
        margin-bottom: 22px;
        /deep/ .el-upload {
          width: 100%;
          height: 100%;
          .main-upload-box {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            position: relative;
            video {
              width: 100%;
              height: 100%;
            }
            .el-icon-plus {
              font-size: 36px;
              color: #8c939d;
              line-height: 148px;
              text-align: center;
            }
            .main-upload-operate {
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.7);
              position: absolute;
              left: 0;
              top: 0;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              visibility: hidden;
              i {
                font-size: 28px;
                color: #008dff;
              }
              i:first-child {
                margin-right: 10px;
              }
              i:last-child {
                margin-left: 10px;
              }
            }
          }
          .main-upload-box:hover .main-upload-operate {
            visibility: visible;
          }
        }
      }
    }
    .content-save {
      width: 148px;
      height: 44px;
      color: #fff;
      background-color: #008dff;
      line-height: 44px;
      text-align: center;
      border-radius: 4px;
      font-size: 18px;
      font-weight: 700;
      display: block;
      margin: 0 auto;
      margin-top: 40px;
      cursor: pointer;
    }
    .content-save:hover {
      opacity: 0.9;
    }
  }
}
.model {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  .preview-image {
    width: 800px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
  }
}

@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 20px;
    .content-top {
      display: none;
    }
    .content-main {
      margin-top: 0;
    }
    .main-title {
      margin: 10px 0;
    }
  }
}
</style>